//# sourceMappingURL=customers.mjs.map
/// <reference types="./customers.d.mts" />
import * as $ai_config from "../../../../data_types/data/ai_config.mjs";
import * as $organization from "../../../../data_types/data/auth/organization.mjs";
import * as $llm_capacity from "../../../../data_types/data/llm_capacity.mjs";
import * as $remote from "../../../../data_types/data/remote.mjs";
import * as $callout from "../../../../ds/ds/components/callout.mjs";
import * as $label from "../../../../ds/ds/components/label.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $loader from "../../../../ds/ds/components/loader.mjs";
import * as $table from "../../../../ds/ds/components/table.mjs";
import * as $typography from "../../../../ds/ds/components/typography.mjs";
import * as $dict from "../../../../gleam_stdlib/gleam/dict.mjs";
import * as $float from "../../../../gleam_stdlib/gleam/float.mjs";
import * as $int from "../../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $order from "../../../../gleam_stdlib/gleam/order.mjs";
import * as $result from "../../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../../gleam_stdlib/gleam/string.mjs";
import * as $h from "../../../../redraw_dom/redraw/dom/html.mjs";
import * as $llm_usage from "../../../data/llm_usage.mjs";
import {
  Ok,
  Error,
  toList,
  Empty as $Empty,
  prepend as listPrepend,
  divideFloat,
  divideInt,
} from "../../../gleam.mjs";

export const langfuse_days = 90;

export const long_window_months = 12;

export const short_window_months = 3;

const model_columns = /* @__PURE__ */ toList([
  ["Answers", /* @__PURE__ */ new $ai_config.Rag()],
  ["Score and style", /* @__PURE__ */ new $ai_config.DefaultModel()],
  ["Translate", /* @__PURE__ */ new $ai_config.TranslateModel()],
]);

function langfuse_cells(langfuse, org, short) {
  let _block;
  if (langfuse instanceof $remote.NotLoaded) {
    _block = ["…", "…"];
  } else if (langfuse instanceof $remote.Loading) {
    _block = ["…", "…"];
  } else if (langfuse instanceof $remote.Errored) {
    _block = ["–", "–"];
  } else {
    let usage = langfuse[0];
    let $1 = $dict.get(usage, org.id);
    if ($1 instanceof Ok) {
      let usage$1 = $1[0];
      _block = [
        $int.to_string(usage$1.questions),
        (() => {
          let $2 = usage$1.questions;
          if ($2 === 0) {
            return "–";
          } else {
            let questions = $2;
            let _pipe = divideFloat(
              $int.to_float(usage$1.calls),
              $int.to_float(questions)
            );
            let _pipe$1 = $float.to_precision(_pipe, 1);
            return $float.to_string(_pipe$1);
          }
        })(),
      ];
    } else {
      _block = ["0", "–"];
    }
  }
  let $ = _block;
  let answered = $[0];
  let calls_per_question = $[1];
  return toList([
    $table.cell(
      $typography.text(
        $typography.sm,
        $typography.regular,
        ($int.to_string(short.questions) + " · ") + answered,
      ),
    ),
    $table.cell(
      $typography.text($typography.sm, $typography.regular, calls_per_question),
    ),
  ]);
}

function trend(short, long) {
  let $ = long.projects;
  if ($ === 0) {
    return $typography.text($typography.xs, $typography.regular, "No projects");
  } else {
    let long_projects = $;
    let per_month = (projects, months) => {
      return divideFloat($int.to_float(projects), $int.to_float(months));
    };
    let ratio = divideFloat(
      per_month(short.projects, short_window_months),
      per_month(long_projects, long_window_months)
    );
    let _block;
    {
      if (ratio >= 1.5) {
        _block = ["Ramping up", $label.current()];
      } else if (ratio <= 0.67) {
        _block = ["Slowing down", $label.neutral_light()];
      } else {
        _block = ["Steady", $label.neutral()];
      }
    }
    let $1 = _block;
    let title = $1[0];
    let status = $1[1];
    return $label.label(
      toList([
        status,
        $label.capitalize(false),
        $label.content(
          (title + " ×") + $float.to_string($float.to_precision(ratio, 1)),
        ),
      ]),
    );
  }
}

function questions_per_proposal(activity) {
  let $ = activity.proposals;
  if ($ === 0) {
    return "–";
  } else {
    let proposals = $;
    return $int.to_string(divideInt(activity.questions, proposals));
  }
}

function months(months) {
  return $int.to_string(months) + " months";
}

function customers_table(customers, short, long, langfuse) {
  let activity = (window, org) => {
    let _pipe = $dict.get(window, org.id);
    return $result.unwrap(_pipe, new $llm_capacity.OrgActivity(org.id, 0, 0, 0));
  };
  let _block;
  let _pipe = $list.map(
    customers,
    (customer) => {
      let org = customer[0];
      let ai_config = customer[1];
      return [org, ai_config, activity(short, org), activity(long, org)];
    },
  );
  _block = $list.sort(
    _pipe,
    (a, b) => {
      let _pipe$1 = $int.compare(b[3].projects, a[3].projects);
      return $order.lazy_break_tie(
        _pipe$1,
        () => { return $string.compare(a[0].display_name, b[0].display_name); },
      );
    },
  );
  let rows = _block;
  return $table.table(
    toList([]),
    toList([
      $table.headers(
        $list.flatten(
          toList([
            toList([
              (() => {
                let _pipe$1 = $table.header("Customer");
                return $table.fraction(_pipe$1, 2);
              })(),
            ]),
            $list.map(
              model_columns,
              (column) => {
                let _pipe$1 = $table.header(column[0]);
                return $table.fraction(_pipe$1, 2);
              },
            ),
            toList([
              (() => {
                let _pipe$1 = $table.header(
                  "Projects, " + months(short_window_months),
                );
                return $table.fit(_pipe$1);
              })(),
              (() => {
                let _pipe$1 = $table.header(
                  "Projects, " + months(long_window_months),
                );
                return $table.fit(_pipe$1);
              })(),
              (() => {
                let _pipe$1 = $table.header("Q / proposal");
                return $table.fit(_pipe$1);
              })(),
              (() => {
                let _pipe$1 = $table.header("Trend");
                return $table.fit(_pipe$1);
              })(),
              (() => {
                let _pipe$1 = $table.header("Questions, created · answered");
                return $table.fit(_pipe$1);
              })(),
              (() => {
                let _pipe$1 = $table.header("LLM calls / question");
                return $table.fit(_pipe$1);
              })(),
            ]),
          ]),
        ),
      ),
      $table.body(
        $list.map(
          rows,
          (_use0) => {
            let org = _use0[0];
            let ai_config = _use0[1];
            let short$1 = _use0[2];
            let long$1 = _use0[3];
            let models_config = ai_config.config.models_config;
            let _pipe$1 = $list.flatten(
              toList([
                toList([
                  $table.cell(
                    $l.column(
                      toList([$l.gap(2)]),
                      toList([]),
                      toList([
                        $typography.text(
                          $typography.sm,
                          $typography.regular,
                          org.display_name,
                        ),
                        $typography.text(
                          $typography.xs,
                          $typography.regular,
                          org.id,
                        ),
                      ]),
                    ),
                  ),
                ]),
                $list.map(
                  model_columns,
                  (column) => {
                    let _pipe$1 = $ai_config.model_for(models_config, column[1]);
                    let _pipe$2 = $ai_config.model_to_string(_pipe$1);
                    let _pipe$3 = ((_capture) => {
                      return $typography.text(
                        $typography.sm,
                        $typography.regular,
                        _capture,
                      );
                    })(_pipe$2);
                    return $table.cell(_pipe$3);
                  },
                ),
                listPrepend(
                  $table.cell(
                    $typography.text(
                      $typography.sm,
                      $typography.regular,
                      $int.to_string(short$1.projects),
                    ),
                  ),
                  listPrepend(
                    $table.cell(
                      $typography.text(
                        $typography.sm,
                        $typography.regular,
                        $int.to_string(long$1.projects),
                      ),
                    ),
                    listPrepend(
                      $table.cell(
                        $typography.text(
                          $typography.sm,
                          $typography.regular,
                          questions_per_proposal(long$1),
                        ),
                      ),
                      listPrepend(
                        $table.cell(trend(short$1, long$1)),
                        langfuse_cells(langfuse, org, short$1),
                      ),
                    ),
                  ),
                ),
              ]),
            );
            let _pipe$2 = $table.row(_pipe$1);
            return $table.row_id(_pipe$2, org.id);
          },
        ),
      ),
    ]),
  );
}

export function customers(organizations, ai_configs) {
  return $list.filter_map(
    organizations,
    (org) => {
      let $ = $dict.get(ai_configs, org.id);
      if ($ instanceof Ok) {
        let $1 = $[0];
        if ($1 instanceof $remote.Loaded) {
          let ai_config = $1[0];
          return new Ok([org, ai_config]);
        } else {
          return new Error(undefined);
        }
      } else {
        return new Error(undefined);
      }
    },
  );
}

function window(activity, months) {
  let _pipe = $dict.get(activity, months);
  return $result.unwrap(_pipe, new $remote.NotLoaded());
}

export function view(organizations, ai_configs, activity, langfuse) {
  let short = window(activity, short_window_months);
  let long = window(activity, long_window_months);
  let $ = customers(organizations, ai_configs);
  if ($ instanceof $Empty) {
    let $1 = $dict.is_empty(ai_configs);
    if ($1) {
      return $loader.loader(toList(["Loading the customers…"]));
    } else {
      return $typography.text(
        $typography.sm,
        $typography.regular,
        "No organization has a readable AI config.",
      );
    }
  } else if (short instanceof $remote.Errored) {
    let error = short[0];
    return $callout.error(
      toList([]),
      toList([$callout.content(toList([]), toList([$h.text(error)]))]),
    );
  } else if (short instanceof $remote.Loaded) {
    if (long instanceof $remote.Errored) {
      let error = long[0];
      return $callout.error(
        toList([]),
        toList([$callout.content(toList([]), toList([$h.text(error)]))]),
      );
    } else if (long instanceof $remote.Loaded) {
      let customers$1 = $;
      let short$1 = short[0];
      let long$1 = long[0];
      return $l.column(
        toList([$l.gap(16)]),
        toList([]),
        toList([
          (() => {
            if (langfuse instanceof $remote.Errored) {
              let error = langfuse[0];
              return $callout.error(
                toList([]),
                toList([$callout.content(toList([]), toList([$h.text(error)]))]),
              );
            } else {
              return $h.none();
            }
          })(),
          customers_table(customers$1, short$1, long$1, langfuse),
          $typography.text(
            $typography.sm,
            $typography.regular,
            ((((((("Trend compares the monthly rate of new projects over the last " + $int.to_string(
              short_window_months,
            )) + " months with the last ") + $int.to_string(long_window_months)) + ": ×1.5 or more is ramping up, ×0.67 or less is slowing down. ") + "Questions created come from the database, questions answered ") + "and LLM calls from Langfuse, over the last ") + $int.to_string(
              langfuse_days,
            )) + " days.",
          ),
        ]),
      );
    } else {
      return $loader.loader(toList(["Loading the activity…"]));
    }
  } else if (long instanceof $remote.Errored) {
    let error = long[0];
    return $callout.error(
      toList([]),
      toList([$callout.content(toList([]), toList([$h.text(error)]))]),
    );
  } else {
    return $loader.loader(toList(["Loading the activity…"]));
  }
}
